/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Review_Pro_DescInputs */

const en_directory_submit_review_pro_desc = /** @type {(inputs: Directory_Submit_Review_Pro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Higher monthly quota, dofollow listings, faster review lane.`)
};

const zh_directory_submit_review_pro_desc = /** @type {(inputs: Directory_Submit_Review_Pro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更高的每月额度、dofollow 外链、更快的审核通道。`)
};

/**
* | output |
* | --- |
* | "Higher monthly quota, dofollow listings, faster review lane." |
*
* @param {Directory_Submit_Review_Pro_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_review_pro_desc = /** @type {((inputs?: Directory_Submit_Review_Pro_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Review_Pro_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_review_pro_desc(inputs)
	return zh_directory_submit_review_pro_desc(inputs)
});
export { directory_submit_review_pro_desc as "directory.submit.review.pro_desc" }